import Second1 from 'assets/main/second1.avif'
import Second2 from 'assets/main/second2.avif'
import Second3 from 'assets/main/second3.avif'
import { motion } from 'framer-motion'
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'components/constants/animation-properties';
import Container from 'components/common/Container';

const Second = () => {
    const data = [
        {
            title: '즉시 견적 • 간편 예약',
            description: ' 만에 견적 받고, 바로 예약하세요',
            list: [
                '출발지·목적지·화물 정보를 한번만 입력하면<br class="wide:hidden block"/>여러 포워더의 운임을 실시간으로 비교·제시',
                '클릭 한 번으로 견적 수락 → 운송 예약까지<br class="wide:hidden block"/>원스톱 처리',
                '복잡한 서류·메일 커뮤니케이션 없이<br class="wide:hidden block"/> 진행 시작'
            ],
            img: Second1
        },
        {
            title: '실시간 트래킹& AI 예측',
            description: '물류의 맥박을 한눈에 AI ETA, Pulse Score',
            list: [
                '글로벌 트래킹 API 연동으로 위치 정보를<br class="wide:hidden block"/>실시간 업데이트',
                'AI 기반 ETA(도착예측)로 예상 도착시간<br class="wide:hidden block"/>자동 제시',
                'Pulse Score로 화물 건강 상태 시각화 및 지연 · <br class="wide:hidden block"/>파손 등 리스크 발생 시 즉시 알림 및 대응 가이드'
            ],
            img: Second2
        },
        {
            title: '문서 자동화',
            description: '서류 관리부터 3D 적재 시뮬레이션 까지 ‘올인원’ 지원',
            list: [
                '사업자등록증 · 상업 송장 자동 OCR 분석과<br class="wide:hidden block"/>필드매핑 서비스 제공',
                '주요 이벤트 발생 시 이메일 및 앱 푸시 알림<br class="wide:hidden block"/>전달을 통해 리스크 최소화',
                'HS 코드 및 3D 적재 가이드로 물류 업무를<br class="wide:hidden block"/>혁신적인 해결방안을 통해 지원'
            ],
            img: Second3
        },
    ]

    return (
        <Container className='flex flex-col items-start py-[200px] wide:py-20 min-h-dvh'>
            <div className='flex flex-col gap-7.5 wide:gap-4 mb-[100px] wide:mb-4 font-normal wide:text-base text-lg text-left'>
                <motion.h2
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                    className='font-bold text-32 wide:text-2xl'>
                    스마트 AI 물류 솔루션 <span className='text-primary'>PulseOnShip</span>
                </motion.h2>
                <motion.h3
                    transition={{ delay: 0.1 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY}
                >
                    누구나 손쉽게 이용 가능한 AI 운임 견적<br /> 추적·서류 자동화까지 한 곳에서 완성되는 통합 물류 관리.
                </motion.h3>
            </div>

            <div className='flex flex-col items-start gap-[180px] wide:gap-20 w-full'>
                {
                    data.map((item, idx) => (
                        <div
                            className={`flex ${idx % 2 !== 0 && 'flex-row-reverse self-end'} items-center justify-between wide:w-full wide:flex-col gap-20`}
                            key={idx}
                        >
                            <motion.div
                                className='overflow-hidden'
                                initial={START_ANIMATION_PROPERTY}
                                whileInView={END_ANIMATION_PROPERTY}
                                viewport={VIEWPORT_PROPERTY}
                            >
                                <img
                                    className='hover:scale-95 transition-transform duration-300'
                                    src={item.img}
                                    alt="secondImg" />
                            </motion.div>
                            <div className='flex flex-col gap-10 wide:gap-4 wide:w-full'>
                                <div>
                                    <motion.p
                                        className='font-semibold text-28'
                                        transition={{ delay: 0.1 }}
                                        initial={START_ANIMATION_PROPERTY}
                                        whileInView={END_ANIMATION_PROPERTY}
                                        viewport={VIEWPORT_PROPERTY}
                                    >
                                        {item.title}
                                    </motion.p>
                                    <motion.p
                                        className='text-[#949494] text-lg'
                                        transition={{ delay: 0.2 }}
                                        initial={START_ANIMATION_PROPERTY}
                                        whileInView={END_ANIMATION_PROPERTY}
                                        viewport={VIEWPORT_PROPERTY}
                                    >
                                        {item.description}
                                    </motion.p>
                                </div>
                                <ul className='flex flex-col gap-6 wide:gap-4 font-normal text-lg'>
                                    {
                                        item.list.map((list, index) => (
                                            <motion.li
                                                transition={{ delay: 0.2 + 0.1 * index }}
                                                initial={START_ANIMATION_PROPERTY}
                                                whileInView={END_ANIMATION_PROPERTY}
                                                viewport={VIEWPORT_PROPERTY}
                                                className='flex items-center gap-6'
                                                key={index}
                                            >
                                                <p className='flex justify-center items-center bg-primary rounded w-12.5 h-12.5 font-semibold text-white text-2xl shrink-0'>0{index + 1}</p>
                                                <p dangerouslySetInnerHTML={{ __html: list }}></p>
                                            </motion.li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                    ))
                }
            </div>
        </Container>
    )
}

export default Second